// Generated file - do not change manually!
/**
 * PageBackgroundDesign
 */
export var PageBackgroundDesign;
(function (PageBackgroundDesign) {
    /**
     * Page background color when a List is set as the Page content.
     */
    PageBackgroundDesign["List"] = "List";
    /**
     * A solid background color dependent on the theme.
     */
    PageBackgroundDesign["Solid"] = "Solid";
    /**
     * Transparent background for the page.
     */
    PageBackgroundDesign["Transparent"] = "Transparent";
})(PageBackgroundDesign || (PageBackgroundDesign = {}));
